/**
 * @packageDocumentation
 * @module f1/is
 */

export interface IsExists {
  /**
   * Same as `v != null`
   *
   * @public
   * @function f1.is.exists
   * @param v is a number
   * @example
   *
   * ```ts
   * f1.is.exists({ any other value }) => { true }
   * f1.is.exists(null) => false
   * f1.is.exists(undefined) => false
   * ```
   */
  <V>(value: V | null | undefined): value is V;
}

/**
 * @see IsExists
 */
export default <V>(value: V | null | undefined): value is V => {
  return null != value;
};
